// The Board of Directors, shown on the team page beside the leadership team.
// Lives in its own module so the roster data is not buried in page layout.
export const boardMembers = [
  {
    name: 'Vijay Sudheendra, M.D.',
    title: 'Acting Chairman of the Board',
    image: '/team/portraits/vijay-sudheendra.jpg',
    affiliations: ['Boston Medical Center', 'USAP Rhode Island', 'Kent Hospital'],
    bio: `Vijay Sudheendra, M.D. is a highly accomplished, board-certified physician anesthesiologist based in Cumberland, Rhode Island. He currently serves as a Clinical Assistant Professor of Anesthesiology at the Boston Medical Center's Avedisian School of Medicine and holds prominent executive leadership roles within U.S. Anesthesia Partners (USAP) Rhode Island and regional healthcare systems. With over two decades of clinical, academic, and administrative experience, Dr. Sudheendra has a distinguished track record in cardiac anesthesia, ambulatory surgery center (ASC) management, and regional medical governance.`,
    rolesHeading: 'Current Leadership & Clinical Roles',
    roles: [
      {
        role: 'Chair, Clinical Governance Board (CGB) & Physician Equity Owner',
        org: 'USAP RI',
        period: 'April 2026 – Present',
      },
      {
        role: 'Clinical Assistant Professor of Anesthesiology',
        org: 'Avedisian School of Medicine, Boston Medical Center',
        period: '2020 – Present',
      },
      {
        role: 'Board Member',
        org: 'Charter Care Healthcare RI (CHRI)',
        period: '2025 – Present',
      },
      {
        role: 'Chief of Anesthesia',
        org: 'Kent Hospital, Warwick, RI',
        period: '2015 – Present, noted also as 2024–Present',
      },
      {
        role: 'Chair – Hospital Peer Review Committee',
        org: 'Roger Williams Medical Center, Providence, RI',
        period: '2023 – Present',
      },
    ],
  },
  {
    name: 'Timothy A. Masterson, M.D., FACS',
    title: 'Board Member',
    image: '/team/portraits/tim-masterson.jpg',
    affiliations: ['Indiana University School of Medicine', 'American Board of Urology'],
    bio: `Timothy A. Masterson, M.D., FACS is a highly accomplished, board-certified urologic surgeon based in Indianapolis, Indiana. He currently serves as a Professor of Urology at the Indiana University School of Medicine and holds prominent leadership roles within the school's faculty governance and national urologic oncology organizations. With over two decades of clinical, academic, and administrative experience, Dr. Masterson has a distinguished track record in urologic oncology, testicular cancer surgery, and academic surgical leadership. He has authored more than 100 peer-reviewed publications and 15 book chapters on surgical outcomes and the management of urologic cancers, and has been named to Indiana's Best Doctors in Urology annually since 2012.`,
    rolesHeading: 'Current Leadership & Clinical Roles',
    roles: [
      {
        role: 'President, IU School of Medicine Faculty & Chair, Faculty Steering Committee',
        org: 'Indiana University School of Medicine',
        period: '2024 – 2026',
      },
      {
        role: 'Professor of Urology, Tenured',
        org: 'Indiana University School of Medicine, Indianapolis, IN',
        period: '2024 – Present',
      },
      {
        role: 'Member, Examination Committee',
        org: 'American Board of Urology',
        period: '2026 – 2030',
      },
      {
        role: 'Fellowship Director, Urologic Oncology Fellowship Program',
        org: 'Society of Urologic Oncology / Indiana University',
        period: '2013 – Present',
      },
      {
        role: 'Chair/Co-Chair, Data Safety Monitoring Committee',
        org: 'IU Simon Cancer Center, IU Health',
        period: '2014 – 2023',
      },
      {
        role: 'Section Editor, Urologic Oncology (journal)',
        org: 'Urologic Oncology: Seminars and Original Investigations',
        period: '2021 – Present',
      },
    ],
  },
  {
    name: 'Ciaran J. McNamee, M.D.',
    title: 'Board Member',
    image: '/team/portraits/ciaran-mcnamee.jpg',
    affiliations: ['Kent Hospital', 'Mass General Brigham', 'Harvard Medical School'],
    bio: `Dr. CJ McNamee is the head of thoracic surgery at Kent Hospital in Warwick Rhode Island, and an associate surgeon in the thoracic surgery division at Mass General Brigham in Boston, Massachusetts. Dr. McNamee is also an assistant professor of surgery at Harvard Medical School.

Dr. McNamee's interests involve incorporating innovations at the frontiers of medical care providing both autonomy and wellbeing for those in need.`,
  },
];

export default boardMembers;
